import * as Backbone from "backbone";
import { CachingCollection } from "./_BaseCollection";

interface DailyReportFilesOptions {
    organizationId: number;
}

export class DailyReportFilesCollection extends CachingCollection<Backbone.Model> {
    public organizationId: number;

    constructor(initialModels?: Object[] | any[], options?: DailyReportFilesOptions) {
        super(initialModels, options);
        this.organizationId = options.organizationId;
    }

    url = () => {
        return window.location.origin + "/api/v1/daily_reports/files/" + this.organizationId;
    };

    downloadReport = () => {
        return window.location.origin + "/api/v1/daily_reports/files/download";
    };
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/DailyReportFiles.ts